import { render, staticRenderFns } from "./TJ-Button.vue?vue&type=template&id=440e25a0&scoped=true&"
import script from "./TJ-Button.vue?vue&type=script&lang=js&"
export * from "./TJ-Button.vue?vue&type=script&lang=js&"
import style0 from "./TJ-Button.vue?vue&type=style&index=0&id=440e25a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e25a0",
  null
  
)

export default component.exports